import React from "react";
import { analytics } from "../analytics";
import "./EmailContactIcon.css";

const EmailContactIcon = ({
  email = "dennis.morozov@effigen.ai",
  subject = "",
  body = "",
  title = "Email us",
  size = 20,
  className = "",
  style = {},
}) => {
  const mailto = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  return (
    <a
      href={mailto}
      className={`email-contact-icon ${className}`.trim()}
      aria-label={title}
      title={title}
      style={style}
      onClick={() => analytics.contactEmailClick({ link_url: email })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    </a>
  );
};

export default EmailContactIcon;
